import React from 'react';
import { ReduxProvider } from './ReduxProvider';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <ReduxProvider>
      {children}
    </ReduxProvider>
  );
};